<template>
  <form class="form" method="get">

    <div class="fontInvoice">
      <div class="invoiceBlocButton">
        <button @click.prevent="printing()" type="submit" class="appButtonModel2 appPrintButton">Imprimer</button>
        <button @click.prevent="returnTo()" type="submit" class="appButtonModel2 appPrintButton">Retour</button>
      </div>
      <div class="appStatisticsPDFEntete">
        <p>Registre des Recettes</p>
        <img src="../../assets/Logo1.png" alt="logo de Privilégia Coiffure" class="appLogoPrivilegiaInvoice" />
      </div>
      <div class="appStatisticsPDFEntete2">
        <p>Du</p>
        <p id="datePDFIncome1"></p>
        <p>Au</p>
        <p id="datePDFIncome2"></p>
        <p>Nombre : </p>
        <p id="appNumberIncomes"></p>
      </div>
      <table class="appStatisticsPDFTable" id="tableToGenerate">
        <tr>
          <td class="appStatisticsPDF04">Date</td>
          <td class="appStatisticsPDF02">Référence pièce</td>
          <td class="appStatisticsPDF03">Client</td>
          <td class="appStatisticsPDF03">Mode de règlement</td>
          <td class="appStatisticsPDF02">Prestation</td>
          <td class="appStatisticsPDF02">Vente</td>
        </tr>
      </table>
    </div>

  </form>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  name: 'appStatisticsPDFIncome',
  data () {
    return {
      invoice: ''
    }
  },
  async mounted () {
    let date1 = localStorage.getItem('privilegiaPDFdate1')
    let date2 = localStorage.getItem('privilegiaPDFdate2')
    document.getElementById('datePDFIncome1').innerText = this.format_date(date1)
    document.getElementById('datePDFIncome2').innerText = this.format_date(date2)
    let subTotalPrestation = 0
    let subTotalVente = 0
    let totalEspeces = 0
    let totalCheques = 0
    let totalCB = 0
    let totalPaylib = 0
    let totalPaypal = 0
    let totalReduction = 0
    let fullTotal = 0
    let subTotalRemise = 0
    let sumOfsubTotalPrestation = 0
    let sumOfsubTotalVente = 0
    let sumOfsubTotalremise = 0
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    await axios
      .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.invoice = response.data.filter(invoice => invoice.categoryOfInvoice === 2 && invoice.dateBank >= date1 && invoice.dateBank <= date2)
        this.invoice.sort((a, b) => (a.number < b.number ? 1 : -1))
        let myTotalCounter = this.invoice.length
        document.getElementById('appNumberIncomes').innerText = myTotalCounter
        for (let myCounter = 0; myCounter < myTotalCounter; myCounter++) {
          subTotalPrestation = 0
          subTotalVente = 0
          subTotalRemise = 0
          // Entrer dans les lignes de chaque commandes
          let myTotalSecondCounter = this.invoice[myCounter].lines.length
          let totalForInvoice = this.invoice[myCounter].paiementEspeces + this.invoice[myCounter].paiementCheques + this.invoice[myCounter].paiementCB + this.invoice[myCounter].paiementPaylib + this.invoice[myCounter].paiementPaypal
          for (let mySecondCounter = 0; mySecondCounter < myTotalSecondCounter; mySecondCounter++) {
            if (this.invoice[myCounter].lines[mySecondCounter].category === 'Prestation') {
              subTotalPrestation = subTotalPrestation + this.invoice[myCounter].lines[mySecondCounter].total
            }
            if (this.invoice[myCounter].lines[mySecondCounter].category === 'Vente') {
              subTotalVente = subTotalVente + this.invoice[myCounter].lines[mySecondCounter].total
            }
            if (this.invoice[myCounter].lines[mySecondCounter].category === 'Remise') {
              subTotalRemise = subTotalRemise + this.invoice[myCounter].lines[mySecondCounter].total
            }
          }
          // Ajuster les montants des remises et réductions
          if (subTotalPrestation === 0) {
            subTotalVente = totalForInvoice
          } else {
            subTotalPrestation = totalForInvoice - subTotalVente
          }
          sumOfsubTotalPrestation = sumOfsubTotalPrestation + subTotalPrestation
          sumOfsubTotalVente = sumOfsubTotalVente + subTotalVente
          sumOfsubTotalremise = sumOfsubTotalremise + subTotalRemise
          // Créer le HTML par lignes
          let newDivDate = document.createElement('td')
          newDivDate.className = 'appStatisticsPDF04 appStatisticsPDFItalic'
          newDivDate.innerText = this.format_date(this.invoice[myCounter].dateBank)
          let newDivReference = document.createElement('td')
          newDivReference.className = 'appStatisticsPDF02 appStatisticsPDFItalic'
          newDivReference.innerText = this.invoice[myCounter].number
          let newDivClient = document.createElement('td')
          newDivClient.className = 'appStatisticsPDF03 appStatisticsPDFItalic'
          newDivClient.innerText = this.invoice[myCounter].client
          let newDivMode = document.createElement('td')
          newDivMode.className = 'appStatisticsPDF01 appStatisticsPDFItalic'
          newDivMode.innerText = this.invoice[myCounter].typeofpaiement
          let newDivPrestation = document.createElement('td')
          newDivPrestation.className = 'appStatisticsPDF03 appStatisticsPDFItalic'
          if (subTotalPrestation === 0) {
            newDivPrestation.innerText = '-'
          } else {
            newDivPrestation.innerText = subTotalPrestation.toFixed(2) + '€'
          }
          let newDivVente = document.createElement('td')
          newDivVente.className = 'appStatisticsPDF01 appStatisticsPDFItalic'
          if (subTotalVente === 0) {
            newDivVente.innerText = '-'
          } else {
            newDivVente.innerText = subTotalVente.toFixed(2) + '€'
          }
          let newLine = document.createElement('tr')
          document.getElementById('tableToGenerate').appendChild(newLine)
          newLine.appendChild(newDivDate)
          newLine.appendChild(newDivReference)
          newLine.appendChild(newDivClient)
          newLine.appendChild(newDivMode)
          newLine.appendChild(newDivPrestation)
          newLine.appendChild(newDivVente)
          subTotalPrestation = 0
          subTotalVente = 0
          subTotalRemise = 0
          // Retour au résumé
          totalEspeces = totalEspeces + this.invoice[myCounter].paiementEspeces
          totalCheques = totalCheques + this.invoice[myCounter].paiementCheques
          totalCB = totalCB + this.invoice[myCounter].paiementCB
          totalPaylib = totalPaylib + this.invoice[myCounter].paiementPaylib
          totalPaypal = totalPaypal + this.invoice[myCounter].paiementPaypal
          fullTotal = totalEspeces + totalCheques + totalCB + totalPaylib + totalPaypal
          totalReduction = totalReduction + this.invoice[myCounter].amountreduction
        }
        // Créer le sous-total HTML
        let newSubTotalline1 = document.createElement('td')
        newSubTotalline1.className = 'appStatisticsPDF01'
        newSubTotalline1.setAttribute('colspan', '4')
        newSubTotalline1.innerText = 'Sous total'
        let newSubTotalline2 = document.createElement('td')
        newSubTotalline2.className = 'appStatisticsPDF02'
        newSubTotalline2.id = 'totalPrestations'
        newSubTotalline2.innerText = sumOfsubTotalPrestation.toFixed(2) + '€'
        let newSubTotalline3 = document.createElement('td')
        newSubTotalline3.className = 'appStatisticsPDF02'
        newSubTotalline3.id = 'totalVentes'
        newSubTotalline3.innerText = sumOfsubTotalVente.toFixed(2) + '€'
        let newSubTotalLine = document.createElement('tr')
        document.getElementById('tableToGenerate').appendChild(newSubTotalLine)
        newSubTotalLine.appendChild(newSubTotalline1)
        newSubTotalLine.appendChild(newSubTotalline2)
        newSubTotalLine.appendChild(newSubTotalline3)
        // Créer le total HTML
        let newTotalline1 = document.createElement('td')
        newTotalline1.className = 'appStatisticsPDF01'
        newTotalline1.setAttribute('colspan', '4')
        newTotalline1.innerText = 'Total Prestations + Ventes'
        let newTotalline2 = document.createElement('td')
        newTotalline2.className = 'appStatisticsPDF01'
        newTotalline2.setAttribute('colspan', '2')
        newTotalline2.id = 'fullTotal'
        newTotalline2.innerText = fullTotal.toFixed(2) + '€'
        let newTotalLine = document.createElement('tr')
        document.getElementById('tableToGenerate').appendChild(newTotalLine)
        newTotalLine.appendChild(newTotalline1)
        newTotalLine.appendChild(newTotalline2)
      })
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    printing () {
      print()
    },
    returnTo () {
      localStorage.removeItem('privilegiaPDFdate1')
      localStorage.removeItem('privilegiaPDFdate2')
      this.$router.go(-1)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppStatisticsPDFIncome.vue